import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { CancelIcon, EditIcon, KPIIcon, SearchesCIcon } from "../../../../SvgIconsData";
import { CrownIcon, DeleteIcon, SpinnerIcon } from "../../../../assets/icons/iconshere";
import CreateKPI from "./createkpi";
import ConfirmBox from "../../../ConfirmBox";
import { labels, monitoringOptions } from "../../../../utils/useWindowDimensions";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { exportMultipleChartsToPdf, generateExcel } from "../../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../../SvgIconsData";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import ProPopup from "../../../layouts/ProPopup";

const kpiDefault = {
  title: "",
  parameters: [
    {
      duration: "MONTHLY",
      values: Array(labels["MONTHLY"].length).fill(0),
      type: "CUSTOM",
      name: null,
    },
    {
      duration: "QUARTERLY",
      values: Array(labels["QUARTERLY"].length).fill(0),
      type: "CUSTOM",
      name: null,
    },
  ],
  graphType: "BAR",
  id: null,
};

const sum = (array) => {
  return array.reduce((accumulator, value) => {
    return accumulator + value;
  }, 0);
};

const KPIList = ({ fetchKPIs, list, loading }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [kpi, setKPI] = useState(kpiDefault);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  const [setDeleteKPI, ShowSetDeleteKPI] = useState(false);
  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  const submitKPI = async () => {
    try {
      if (kpi.title.trim().length > 0) {
        if (!kpi.id) {
          await axios.post(`${configData.config.UNO_URL}/api/kpi/create/${userData.user.group.uuid}`, kpi, {
              headers: {
                Authorization: `Bearer ${userData.token}`,
              },
            }
          );
        } else {
          await axios.post(`${configData.config.UNO_URL}/api/kpi/update/${kpi.uuid}`, kpi, {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          });
        }
        setShow(false);
        fetchKPIs();
      } else {
        setError("Enter a valid KPI Title");
        setTimeout(() => setError(null), 3000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const DeleteKPI = async () => {
    try {
      await axios.post(
        `${configData.config.UNO_URL}/api/kpi/delete/${kpi.uuid}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      fetchKPIs();
    } catch (error) {
      console.log(error);
    }
    ShowSetDeleteKPI(false);
  };

  const tableData1 = [["KPI Report", ""], ["Team Name", userData.user.group.name],
  ["Report Generated at", moment().format("lll")]];
  const arr = [];

  list.map((item) => {
    let title = item.title;
    let targetMetric = item.parameters[0].name;
    let monitoringMetric = item.parameters[1].name;
    let targetAggregate = sum(item.parameters[0].values);
    let monitoingAggregate = sum(item.parameters[1].values);
    arr.push([title, targetMetric, targetAggregate, monitoringMetric, monitoingAggregate]);
  });

  const tableData2 = [
    ["KPI Name", "Target Metric", "Target Aggregate", "Monitoring Metric", "Monitoring Aggregate"],
    ...arr,
  ];

  const loadBox = 4;
  const tileCards = [];

  for (let i = 0; i < loadBox; i++) {
      tileCards.push(
              <tr >
                <td>
                <Skeleton width="13w" className='my-1' />
                </td>
                <td className="text-center">
                <Skeleton width="5vw" className='my-1' />
             </td>
                <td className="text-center">
                <Skeleton width="3vw" className='my-1' />
                  </td>
                <td className="text-center">
                <Skeleton width="5vw" className='my-1' />
                </td>
                <td className="text-center">
                <Skeleton width="3vw" className='my-1' />
                  </td>
                <td className="align-middle text-center userdrop">
                <Skeleton width="3vw" className='my-1' />
                </td>
              </tr>
            );
  }

  const handleEdit = (item) => {
    if (( userPlan && userPlan?.kpi?.create )) {
      setShow(true);
      setKPI(item);
    } else {
      setOpenPro(true);
    }
  };

  const handleDelete = (item) => {
    if ((userPlan && userPlan?.kpi?.create )) {
      ShowSetDeleteKPI(true);
      setKPI(item);
    } else {
      setOpenPro(true);
    }
  };

  const [pdfSpinner, setPdfSpinner] = useState(false);
  const [excelSpinner, setExcelSpinner] = useState(false);

  const handleClickPdfDownload = async(name, table1, table2) => {
    setPdfSpinner(true);
    await exportMultipleChartsToPdf(name, table1, table2)
    setPdfSpinner(false);
  }

  const handleClickExcelDownload = async(name, table1, table2) => {
    setExcelSpinner(true);
    await generateExcel(name, table1, table2)
    setTimeout(()=>setExcelSpinner(false), 500 )
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row  pt-5 pb-2">
          <div className="col-md-4 p-0">
            <div className="app-search app-search1 d-flex ">
              <div className="position-relative">
                <SearchesCIcon />
                {search.length > 0 && (
                  <span className="searchiconcancel" onClick={() => setSearch("")}>
                    <CancelIcon />
                  </span>
                )}
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                />
              </div>
            </div>
          </div>
          <div className="col-md-8 d-flex justify-content-end gap-2 p-0">
          
          {userData.user.permissions.includes('XR.DASHBOARD.KPI') && 
            <>
            {userPlan?.kpi?.create ?
              <button onClick={() => { setShow(true); setKPI(kpiDefault) }}
                className="DefaultRedBtn">
                <KPIIcon /> Create KPI
              </button> 
              :
              <button className="DefaultRedBtn pro" onClick={() => setOpenPro(true)}>
              <CrownIcon  />                                
              <p> Download & Create KPI </p>
              </button>
              }
            </>}

           { userPlan && userPlan["kpi"].download &&
             <>
              <button
                className="DefaultRedBtn download px-2"
                title="Download PDF"
                onClick={() => handleClickPdfDownload("KPI_REPORT", tableData1, tableData2)}>
                {pdfSpinner ? <SpinnerIcon /> : <PDFDownloadIcon />}
              </button>
              <button
                className="DefaultRedBtn download px-2"
                title="Download Excel"
                onClick={() => handleClickExcelDownload("KPI_REPORT", tableData1, tableData2)}>
                {excelSpinner ? <SpinnerIcon /> : <EXLDownloadIcon />}
              </button>
            </>
            }

          </div>
        </div>
        <div className="row pt-2">
          <div className="table-responsive workflowtb p-0 ">
            <table className="table align-middle table-nowrap mb-0 ">
              <thead>
                <tr>
                  <th>KPI Name</th>
                  <th className="text-center">Target Metric</th>
                  <th className="text-center">Target Aggregate</th>
                  <th className="text-center">Monitoring Metric</th>
                  <th className="text-center">Monitoring Aggregate</th>
                  {userData.user.permissions.includes('XR.DASHBOARD.KPI') && <th style={{ textAlign: "center" }}>Action</th>}
                </tr>
              </thead>
              <tbody>
                { loading ? 
                <>
                 {tileCards}
                 </>
                 :
                <>
                {list.map((item, index) => {
                  if (search.length && !item.title.includes(search)) return null;
                  return (
                    <tr key={item.uuid}>
                      <td>{item.title}</td>
                      <td className="text-center">
                        {item.parameters[0].type == "CUSTOM"
                          ? item.parameters[0].name
                          : monitoringOptions[item.parameters[0].type]}
                      </td>
                      <td className="text-center">{sum(item.parameters[0].values)}</td>
                      <td className="text-center">
                        {item.parameters[1].type == "CUSTOM"
                          ? item.parameters[1].name
                          : monitoringOptions[item.parameters[1].type]}
                      </td>
                      <td className="text-center">{sum(item.parameters[1].values)}</td>
                      {userData.user.permissions.includes('XR.DASHBOARD.KPI') && <td className="align-middle text-center userdrop">
                        <Dropdown>
                          
                          <Dropdown.Toggle id="dropdown-basic">
                            <div className="options">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-three-dots-vertical"
                                viewBox="0 0 16 16">
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                              </svg>
                            </div>
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="sidebartopbar modulelistoptions">
                            <div className="listoptionsmodule">
                              <p
                                onClick={() => handleEdit(item) }>
                                <EditIcon />
                                Edit
                              </p>
                              <p
                                onClick={() => handleDelete(item)}>
                                <DeleteIcon />
                                Delete
                              </p>
                            </div>
                          </Dropdown.Menu>

                        </Dropdown>
                      </td>}
                    </tr>
                  );
                })}
                </>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <CreateKPI
        show={show}
        handleClose={() => setShow(false)}
        kpi={kpi}
        setKPI={setKPI}
        submit={submitKPI}
        error={error}
      />
      <ConfirmBox
        title={"Delete KPI"}
        message={"Do you really want to delete this KPI?"}
        show={setDeleteKPI}
        handleSubmit={() => DeleteKPI()}
        handleClose={() => ShowSetDeleteKPI(false)}
      />
    <ProPopup openPro={openPro} setOpenPro={setOpenPro} />          

    </>
  );
};

export default KPIList;